import { DateTime } from 'luxon';

export const LocalDatetimeToUtcIso = (date: string) => {
	const belgianDate = DateTime.fromISO(date, { zone: 'Europe/Brussels' });

	if (!belgianDate.isValid) {
		throw new Error(`Entrée invalide: ${belgianDate.invalidReason}`);
	}

	return belgianDate.toUTC().toISO();
};

/** Comme `LocalDatetimeToUtcIso`, pour un champ optionnel (date de vol/train) : vide reste `null`. */
export const LocalDatetimeToUtcIsoOrNull = (date: string | null | undefined) =>
	date ? LocalDatetimeToUtcIso(date) : null;

/** Comme `UtcIsoToBelgianDatetimeLocalInput`, pour un champ optionnel : vide reste `null`. */
export const UtcIsoToBelgianDatetimeLocalInputOrNull = (date: string | null | undefined) =>
	date ? UtcIsoToBelgianDatetimeLocalInput(date) : null;

export const UtcIsoToBelgianDatetimeLocalInput = (date: string) => {
	const belgianDate = DateTime.fromISO(date, { zone: 'utc' }).setZone('Europe/Brussels');

	if (!belgianDate.isValid) {
		throw new Error(`Entrée invalide: ${belgianDate.invalidReason}`);
	}

	return belgianDate.toFormat("yyyy-MM-dd'T'HH:mm");
};
